module.exports = __webpack_public_path__ + "static/img/11.aa24175e.gif";